import { MESSAGES } from "@app/constant";
import { throwImageFiltering } from "@app/helpers/uploadFileValidation";

import { onChangeUploadProps } from "./types";
import { blogFirstKey } from "./constant";

export const onChangeUpload = ({
  index,
  event,
  watch,
  setValue,
  setState,
  setError,
}: onChangeUploadProps) => {
  // eslint-disable-next-line no-debugger
  // debugger;

  setState((prev) => ({ ...prev, largeImageMessage: '' }))

  const images = watch(`${blogFirstKey}.${index}.image`)

  // I had to add this condition for image different type
  // which one is FileList and second is Image (interface)
  const calcedCount = images instanceof FileList ? images?.length || 0 : images ? 1 : 0

  try {
    const fileList = event.target?.files as FileList;
    const onChangeFiles = throwImageFiltering(fileList)
    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    if (!onChangeFiles) {
      setError(`${blogFirstKey}.${index}.image`, { message: MESSAGES.imageIsRequired })
    }

    if (((calcedCount) + chosenImagesLength) > 5) {
      setError(`${blogFirstKey}.${index}.image`, { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList.length !== onChangeFiles.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    setValue(`${blogFirstKey}.${index}.image`, onChangeFiles)
  } catch (error) {
    console.log('Error:', error);
  }
}
